export const VERSION = '0.8.0';
